import { render, staticRenderFns } from "./StaffValidate.vue?vue&type=template&id=1f17cd00&scoped=true&"
import script from "./StaffValidate.vue?vue&type=script&lang=js&"
export * from "./StaffValidate.vue?vue&type=script&lang=js&"
import style0 from "./StaffValidate.vue?vue&type=style&index=0&id=1f17cd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17cd00",
  null
  
)

export default component.exports